import React, { useEffect, useMemo, useState } from 'react'
import { styled, } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Button, Typography, gridClasses, useMediaQuery } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Stack } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ConfirmDialog from '../Modals/ConfirmDialog';
import ConfirmAdminDialog from '../Modals/ConfirmAdminDialog';
import { useDispatch, useSelector } from 'react-redux';
import { useDeleteAddressMutation, useDeleteCartMutation, useDeleteFavoriteMutation, useDeleteUserMutation, useGetAllCartsQuery, useGetAllChargersQuery, useGetAllFavoritesQuery, useGetAllHeadphonesQuery, useGetAllItemsQuery, useGetAllPhonecasesQuery, useGetAllSmartphonesQuery, useGetAllUsersQuery, useGetCartQuery, useGetUserAddressesQuery, useUpdateUserMutation } from '../../features/fullApi';
import { useTheme } from '@mui/material/styles';
import ClipLoader from 'react-spinners/ClipLoader';
import { toast } from 'react-hot-toast';
import { DataGrid } from '@mui/x-data-grid';
import User from './User';
import moment from 'moment'
import { grey } from '@mui/material/colors';
import UserActions from './UserActions';
import { current } from '@reduxjs/toolkit';
import Error500 from '../ErrorPages/Error500';
import { CSVLink, CSVDownload } from "react-csv";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#FCF6B1",
    color: "#000",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));




const Users = () => {
  window.scrollTo(0, 0);
  const [rowId, setRowId] = useState(null)
  const [currentUser, setCurrentUser] = useState({})


  
  const {data:allProducts, error: errorAllProducts, isLoading:isLoadingAllProducts} = useGetAllItemsQuery();
 
  const [csvData, setCsvData] = useState([])
  let csvHeaders = ["objectID", "title", "price", "brand", "img"];

  useEffect(() => {
    if(!isLoadingAllProducts) {
      setCsvData(csvData => [...csvData, csvHeaders])
      allProducts.map(product => {
        let prodObj = [product._id, product.title, product.price, product.brandId, product.img]
        setCsvData(csvData => [...csvData, prodObj])
      })
      
    }
  }, [isLoadingAllProducts])

  console.log("###CSV DATA IS###", csvData)

  const openDeleteModal = ((productId) => {
    setOpen(true)
  })

  const {data:userAddresses, error:errorUserAddresses, isLoading:isLoadingUserAddresses} = useGetUserAddressesQuery()

  const handleDelete = (async (userId) => {
    deleteUser({id: userId})
    deleteCartForUserDeleted(userId)
    deleteFavoriteForUserDeleted(userId)
    deleteUserAddresses()
    toast.success("User deleted successfully")
    setOpen(false)
  })

  const columns = useMemo(() => [
    {field:'username', headerName:'Username', width:150},
    {field:'email', headerName:'Email', width:250},
    {field:'isAdmin', headerName:'isAdmin', width:100,  
    type: 'singleSelect',   
    valueOptions: ['true'],
    editable: true,
    sortable:false,
    filterable:false},

    {field:'createdAt', headerName:'createdAt', width:200, rederCell:params=>moment(params.row.createdAt).format('YYYY-MM-DD HH:MM:SS')},
    {
      field: 'Orders',
      headerName: 'Orders',
      width: 150,
      renderCell:params=> <Button variant="outlined" onClick={() => navigate(`/orders/find/${params.row._id}`)}>View</Button>,
      sortable:false,
      filterable:false
    },
    {
      field: 'Delete',
      headerName: 'Delete',
      width: 150,
      sortable:false,
      filterable:false,
      renderCell:params=> <Button variant="outlined" onClick={() => 
      {openDeleteModal()
      setCurrentUser(params)
      }}>Delete</Button>,
    },
    {
      field: 'save',
      headerName: 'Save',
      width:'200',
      type: 'save',
      sortable:false,
      filterable:false,
      renderCell: (params) => (
        <UserActions {...{ params, rowId, setRowId }} />
      ),
    },
  ], [rowId])

  const useStyles = makeStyles({
    root: {
        "& .MuiTableCell-head": {
            color: "white",
            backgroundColor: "blue"
        },
    }
  });

  const { classes } = useStyles();
    const navigate = useNavigate()
    const [allUsers, setAllUsers] = useState([])
    
    const [open, setOpen] = useState(false)
    const [openAdmin, setOpenAdmin] = useState(false)

    let user = useSelector(state => state.auth.user)
    if(!user) {
      user = JSON.parse(localStorage.getItem('user')) || ""
    }
    const {data, error, isLoading} = useGetAllUsersQuery(user?._id);
    const {data: carts, error: cartsError, isLoading: isLoadingCarts} = useGetAllCartsQuery()
    const {data: favorites, error:favoritesError, isLoading: isLoadingFavorite} = useGetAllFavoritesQuery()
    const [updateUser] = useUpdateUserMutation()

    const [deleteUser] = useDeleteUserMutation()
    const [deleteCart] = useDeleteCartMutation()
    const [deleteAddress] = useDeleteAddressMutation()
    const [deleteFavorite] = useDeleteFavoriteMutation()


    const theme = useTheme()
 
    const isXs= useMediaQuery(theme.breakpoints.down('xs'));
    const isSm= useMediaQuery(theme.breakpoints.down('sm'));
    const isMd= useMediaQuery(theme.breakpoints.down('md'));
    const isLg= useMediaQuery(theme.breakpoints.down('lg'));
    const isXl= useMediaQuery(theme.breakpoints.down('xl'));

    const dispatch = useDispatch()

    const deleteCartForUserDeleted = (userId) => {
        carts.map((cart) => {
          if(userId === cart.userId) {
          deleteCart({id: cart._id})
      }})
    }

    
    const deleteFavoriteForUserDeleted = (userId) => {
      favorites.map((favorite) => {
        if(userId === favorite.userId) {
        deleteFavorite({id: favorite._id})
    }})
  }

  const deleteUserAddresses = () => {
    userAddresses.map(address => {
      deleteAddress(address._id)
    })
  }


    const makeAdmin = async (id) => {
      console.log("id is", id)
      if (window.confirm('Make this user admin ?')) {
        updateUser({_id: id, isAdmin: true}, { 
        }, {id: id})
        .then(res => {
          navigate("/users")
        })
        .catch(() => {
        })
    }
  }

    const openModal = ((userId) => {
      setOpen(true)
    })

    const openModalMakeAdmin = ((userId) => {
      setOpenAdmin(true)
    })

    const {data: cartData, error: cartError, isLoading: cartIsLoading} = useGetCartQuery()
    console.log("cartData", cartData)


    const handleMakeAdmin = (async (userId) => {
      console.log("user id inside update", userId.id);
      updateUser({_id: userId.id, isAdmin: true}, {id: userId.id},{ 
        headers: {
          'Token': `Bearer ${user?.accessToken}`
        }
      })
      .then(res => {
        console.log("Res is", res);
      })
      .catch((e) => {
        console.log("e is", e)
      })
      setOpenAdmin(false)
    })

    const [pageSize, setPageSize] = React.useState(5);

    const message = "Are you sure you want to delete this user ?"
    const makeAdminMessage = "Are you sure you want to make this user admin ?"


    const {data: products, error: errorProducts, isLoading: isLoadingProducts} = useGetAllSmartphonesQuery();

    const {data: phonecases, error: errorPhonecases, isLoading: isLoadingPhonecases} = useGetAllPhonecasesQuery();

    const {data: chargers, error: errorChargers, isLoading: isLoadingChargers} = useGetAllChargersQuery();

    const {data: headphones, error: errorHeadphones, isLoading: isLoadingHeadphones} = useGetAllHeadphonesQuery();


    const headers = [
      {
        label: "objectID", key: "objectID"
      },
      {
        label: "name", key: "name"
      },
      {
        label: "brandId", key: "brandId"
      },
      {
        label: "img", key: "img"
      },
      {
        label: "category", key: "category"
      },
      {
        label: "price", key: "price"
      }
    ]

    let allProductsArray = []
    products?.map(product => {
      let productName = product.title
      let productBrand = product.brandId
      let productId = product._id
      let categoryName="smartphones"
      let imageLink=product.img
      let productPrice = product.price
      allProductsArray.push({objectID: productId, name: productName, brandId: productBrand, img: imageLink, category: categoryName, price: productPrice})
    })

    phonecases?.map(phonecase => {
      let phonecaseName = phonecase.phonecaseName
      let phonecaseBrand = phonecase.brandId
      let phonecaseId = phonecase._id
      let categoryName="phonecases"
      let imageLink=phonecase.img
      let phonecasePrice = phonecase.price
      allProductsArray.push({objectID: phonecaseId, name: phonecaseName, brandId: phonecaseBrand, img: imageLink, category: categoryName, price: phonecasePrice})
    })

    headphones?.map(headphone => {
      let headphoneName = headphone.headphonesName
      let headphoneBrand = headphone.brandId
      let headphoneId = headphone._id
      let categoryName="headphones"
      let imageLink = headphone.img
      let headphonePrice = headphone.price
      allProductsArray.push({objectID: headphoneId, name: headphoneName, brandId: headphoneBrand, img: imageLink, category: categoryName, price: headphonePrice})
    })

    chargers?.map(charger => {
      let chargerName = charger.chargerName
      let chargerBrand = charger.brandId
      let chargerId = charger._id
      let categoryName="chargers"
      let imageLink = charger.img
      let chargerPrice = charger.price
      allProductsArray.push({objectID: chargerId, name: chargerName, brandId: chargerBrand, img: imageLink, category: categoryName, price: chargerPrice})
    })

    let today = new Date();
    let date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    let time = today.getHours() + '-' + today.getMinutes() + '-' + today.getSeconds();
    const csvLink = {
      filename: `${user.username}:Date:${date}_Time:${time}.csv`,
      headers: headers,
      data: allProductsArray
    }

    const [openEdit, setOpenEdit] = useState(false)
    const openModalEditItem = ((id) => {
      console.log("ID", id)
      setOpenEdit(true)
    })

    const handleUpdateUser = ((user) => {
      console.log("USER SENT IS",)
      setOpenEdit(false)
      updateUser({_id: user._id, username: user.username, email: user.email}, { 
        headers: {
          'Token': `Bearer ${user?.accessToken}`
        }
      }).then(
        toast.success("User edited successfully")
      )
    })

    const renderMobileUsers = () => (
      isLoading ? (<div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 64px)'}}>
      <ClipLoader
        color="#93032E"
        loading={isLoading}
        size={150}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>) : 
      (<>
      {data &&
      <div style={{marginTop: '70px', minHeight: '100vh', marginBottom:'40px'}}>
        <h3 style={{textAlign: 'center', margin: '0px', padding: '20px'}}>Users</h3>
        <TableContainer component={Paper}>
          <Table aria-label="customized table">
            <TableHead>
              <StyledTableRow sx={{
                    "& th": {
                      color: "rgba(96, 96, 96)",
                      backgroundColor: "pink",
                      fontWeight: 'bold'
                    }
                  }}>
                <TableCell>Username</TableCell>
                <TableCell>Orders</TableCell>
                <TableCell>Edit</TableCell>
                <TableCell>Delete</TableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody sx={{maxWidth:'400px'}}>
              {data.map((userData) => (
                  <User userData={userData}/>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      }
     </>)
    )

    const renderTabletUsers = () => (
      isLoading ? (<div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 64px)'}}>
      <ClipLoader
        color="#5B5F97"
        loading={isLoading}
        size={150}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>) : 
    (
      <>
      {data &&
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">Users</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((user) => (
              <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', padding: '10px'}}>
              <TableRow key={user.name}>
                <div>
                  <StyledTableCell align="center">{user.username}</StyledTableCell>
                  <StyledTableCell align="center">{user.email}</StyledTableCell>
                </div>
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <StyledTableCell align="center">
                    <Button onClick={() => navigate(`/orders/find/${user._id}`)}variant="contained" size="small">View orders</Button>
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <Stack direction="row">
                    <Button aria-label="Edit User" onClick={() => navigate(`/users/find/${user._id}`)}>
                        <EditIcon color="primary"/>
                    </Button>
                    <Button aria-label="Delete User" onClick={() => openModal(user._id)}>
                        <DeleteIcon style={{color: 'red'}}/>
                    </Button>
                    <ConfirmDialog open={open} handleDelete={handleDelete} setOpen={setOpen} item={user} message={message}></ConfirmDialog>
                    {user.isAdmin ?
                    <Button aria-label="Make Admin" disabled onClick={() => handleMakeAdmin(user._id)}>
                        <AdminPanelSettingsIcon style={{color: 'green'}}/>
                    </Button>
                    : 
                    <>
                      <Button aria-label="Make Admin" onClick={() => openModalMakeAdmin(user._id)}>
                        <AdminPanelSettingsIcon style={{color: 'red'}}/>
                      </Button>
                      <ConfirmAdminDialog openAdmin={openAdmin} handleMakeAdmin={handleMakeAdmin} setOpenAdmin={setOpenAdmin} item={user} message={makeAdminMessage}></ConfirmAdminDialog>
                    </>
                    }
                    </Stack>
                  </StyledTableCell>
                </div>
              </TableRow>
              </div>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      }
     </>
    )
    )

    // const renderDesktopUsers = () => (
    //   isLoading ? (
    //   <div 
    //   style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
    //   <ClipLoader
    //     color="#93032E"
    //     loading={isLoading}
    //     size={150}
    //     aria-label="Loading Spinner"
    //     data-testid="loader"
    //   />
    // </div>) : 
    //  (<div style={{height: "100vh", width:'1200px', margin:'104px auto 0'}}>
    //   {data &&
    //   <TableContainer component={Paper}>
    //     <Table sx={{ minWidth: 700 }}>
    //       <TableHead>
    //         <TableRow>
    //           <StyledTableCell align="center">Username</StyledTableCell>
    //           <StyledTableCell align="center">Email</StyledTableCell>
    //           <StyledTableCell align="center">Orders</StyledTableCell>
    //           <StyledTableCell align="center">Actions</StyledTableCell>
    //         </TableRow>
    //       </TableHead>
    //       <TableBody>
    //         {data.map((user) => (
    //           <TableRow key={user.name}>
    //             <StyledTableCell align="center">{user.username}</StyledTableCell>
    //             <StyledTableCell align="center">{user.email}</StyledTableCell>
    //             <StyledTableCell align="center">
    //               <Button variant="outlined" style={{width:'110px'}} onClick={() => navigate(`/orders/find/${user._id}`)} size="small">View orders</Button>
    //             </StyledTableCell>
    //             <StyledTableCell align="center">
    //               <Stack direction="row">
    //               <Button aria-label="Delete User" onClick={() => openModal(user._id)}>
    //                   <DeleteIcon style={{color: 'red'}}/>
    //               </Button>
    //               <ConfirmDialog open={open} handleDelete={handleDelete} setOpen={setOpen} item={user} message={message}></ConfirmDialog>
    //               {user.isAdmin ?
    //               <Button aria-label="Make Admin" disabled onClick={() => makeAdmin(user._id)}>
    //                   <AdminPanelSettingsIcon style={{color: 'green'}}/>
    //               </Button>
    //               : 
    //               <>
    //               <Button aria-label="Make Admin" onClick={() => openModalMakeAdmin(user._id)}>
    //                 <AdminPanelSettingsIcon style={{color: 'red'}}/>
    //               </Button>
    //               <ConfirmAdminDialog openAdmin={openAdmin} handleMakeAdmin={handleMakeAdmin} setOpenAdmin={setOpenAdmin} item={user} message={makeAdminMessage}></ConfirmAdminDialog>
    //             </>
    //               }
    //               </Stack>
    //             </StyledTableCell>
    //           </TableRow>
    //         ))}
    //       </TableBody>
    //     </Table>
    //   </TableContainer>
    //   }
    //  </div>)
    // )

    const renderDesktopUsers = () => (
      isLoading ? (
      <div 
      style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <ClipLoader
        color="#93032E"
        loading={isLoading}
        size={150}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>) : 
     error ? (<Error500></Error500>)
     :
     (    
     <div style={{width: '1200px', margin:'122px  auto 0px', height:'100vh'}}>
      <div style={{display:'flex', justifyContent:'center', alignItems:'center', marginBottom:'40px'}}>
        <Typography variant="h5" style={{marginRight:'10px'}}>Users</Typography>
      </div>
      <div style={{width:'1200px', display:'flex', justifyContent:'center', alignItems:'center', marginBottom:'20px'}}>
        <Button sx={{width:'250px', margin:'0 auto'}} color="primary" variant="contained" size="large">
          <CSVLink data={csvData} style={{textDecoration: 'none', borderRadius: '5px', color:'#fff'}}>Download Products CSV</CSVLink>
        </Button>
      </div>

     <DataGrid 
      columns={columns}
      rows={data}
      getRowId={(row) => row._id}
      pageSize={pageSize}
      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
      getRowSpacing={params => ({
        top:params.isFirstVisible ? 0 : 5,
        bottom: params.isLastVisible ? 0 : 5,
      })}
      initialState={{
        ...data.initialState,
        pagination: { paginationModel: { pageSize: 18 } },
      }}
      sx={{
        [`& .${gridClasses.row}`] : {
          bgcolor: theme=>theme.palette.mode === "light" ? grey[200] : grey[900]
        }
      }}
      onCellEditStop={(params) => 
        {
          if(params.row.isAdmin) {
            toast("User is already admin")
          } else {
          setRowId(params.id)
          }
        }
      }
    />
     <ConfirmDialog open={open} handleDelete={handleDelete} item={currentUser} setOpen={setOpen} message={message}></ConfirmDialog>
    </div>)
    )

    return (
      <div>
          {
          (isXs) ?  renderMobileUsers() : 
          (isSm) ? renderMobileUsers() :
          (isMd) ? renderTabletUsers() :
          renderDesktopUsers()
        }
      </div>
    );
}

export default Users